<style lang="scss">
.stats-page{
  .ui-tab{
    li{
      list-style: none;
      margin: 0 10px;
      cursor: pointer;
      border-bottom: 2px solid transparent;

      &.active {
        font-weight: bold;
        border-bottom-color:  $mauve;
      }
    }
  }

  .ui-stats-item{
    max-width: 800px;
    margin: auto;
    border: 2px solid $mauve;
    border-radius: 15px;
    padding: 20px;
  }

  .ui-tab-item{
    .apex-pie-wrapper{
      max-width: 800px;
      margin: auto;
    }
  }
}
</style>

<template>
  <div class="stats-page theme-color-wrapper p-2">
    <div class="row">
      <div class="col-12">
        <h2 class="font-weight-bold" cy="page-title">
          Statistics
        </h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex pt-0">
        <div class="ui-spacer"></div>
        <section>
          <label>Number of days for stats</label>
          <select @change="refreshTabs()" cy="day-input" style="max-width: 200px" class="form-control select-arrow" v-model="filters.days">
            <option value="7">7</option>
            <option value="10">10</option>
            <option value="14">14</option>
            <option value="21">21</option>
            <option value="30">30</option>
          </select>
        </section>
      </div>

      <div class="col-12 my-2">
        <ul class="d-inline-flex align-items-center justify-content-center full-width text-center ui-tab">
          <li class="title-divider" :class="{'active': activeTab === 1}" @click="activeTab = 1">Call Stats</li>
          <li class="title-divider" :class="{'active': activeTab === 2}" @click="activeTab = 2">Busiest Day</li>
          <li class="title-divider" :class="{'active': activeTab === 3}" @click="activeTab = 3">Cancellation Reasons</li>
<!--          <li class="title-divider" :class="{'active': activeTab === 4}" @click="activeTab = 4">{{'prisoner' | term(true)}} Feedback</li>-->
<!--          <li class="title-divider" :class="{'active': activeTab === 5}" @click="activeTab = 5">Feedback</li>-->
          <li class="title-divider" :class="{'active': activeTab === 6}" @click="activeTab = 6">Caller Users</li>
<!--          <li class="title-divider" :class="{'active': activeTab === 7}" @click="activeTab = 7">Additional Caller Users</li>-->
<!--          <li class="title-divider" :class="{'active': activeTab === 8}" @click="activeTab = 8">Booking slot usage</li>-->
        </ul>
      </div>

      <div class="col-12">
        <div class="ui-tab-item" v-if="activeTab === 1">
          <call-stats :filters="filters"></call-stats>
        </div>
        <div v-if="activeTab === 2" class="ui-tab-item">
          <busiest-day-stats :filters="filters"></busiest-day-stats>
        </div>
        <div v-if="activeTab === 3" class="ui-tab-item">
          <cancellation-reason-stats :filters="filters"></cancellation-reason-stats>
        </div>
        <div v-if="activeTab === 4" class="ui-tab-item">
          <prisoner-feedback-stats :filters="filters"></prisoner-feedback-stats>
        </div>
        <div v-if="activeTab === 5" class="ui-tab-item">
          <feedback-stats :filters="filters"></feedback-stats>
        </div>
        <div v-if="activeTab === 6" class="ui-tab-item">
          <visitor-users-stats key="user" :filters="filters"></visitor-users-stats>
        </div>
        <div v-if="activeTab === 7" class="ui-tab-item">
          <visitor-users-stats key="add" :additional-user="true" :filters="filters"></visitor-users-stats>
        </div>
        <div v-if="activeTab === 8" class="ui-tab-item">
          <booking-slot-stats :filters="filters"></booking-slot-stats>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BusiestDayStats from './sections/BusiestDayStats.vue';
  import CancellationReasonStats from './sections/CancellationReasonStats.vue';
  import PrisonerFeedbackStats from './sections/PrisonerFeedbackStats.vue';
  import FeedbackStats from './sections/FeedbackStats.vue';
  import VisitorUsersStats from './sections/VisitorUsersStats.vue';
  import CallStats from './sections/CallStats.vue';
  import { mapState } from 'vuex';
  import BookingSlotStats from './sections/BookingSlotStats';
  import HelperService from '../../services/HelperService';

  export default {
    name: 'stats',
    props: [''],
    components: {
      BusiestDayStats,
      CancellationReasonStats,
      PrisonerFeedbackStats,
      FeedbackStats,
      VisitorUsersStats,
      CallStats,
      BookingSlotStats
    },
    data() {
      return {
        helperService: new HelperService(),
        activeTab: 1,
        filters: {
          prisonId: '',
          prisonGroupId: '',
          days: 7,
        },
        isIE: false,
      };
    },
    computed: mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
    }),
    async mounted() {
      await this.$store.dispatch('prison/getPrison');
      this.filters.prisonId = this.prison.prison_id;
      this.isIE = this.helperService.isIe();
    },
    methods: {
      refreshTabs() {
        let tab = this.activeTab;
        this.activeTab = 0;

        setTimeout(() =>{
          this.activeTab = tab;
        });
      },
    },
  };
</script>
